var map = {
	"./32px/ID-card-32px.svg": 1086,
	"./32px/bar-chart-up-32px.svg": 1087,
	"./32px/bill-2-32px.svg": 1088,
	"./32px/binoculars-32px.svg": 1089,
	"./32px/bulb-idea-32px.svg": 1090,
	"./32px/chat-3-32px.svg": 1091,
	"./32px/coins-2-32px.svg": 1092,
	"./32px/construction-helmet-32px.svg": 1093,
	"./32px/diploma-3-32px.svg": 1094,
	"./32px/discount-star-32px.svg": 1095,
	"./32px/document-pencil-32px.svg": 1096,
	"./32px/fag-og-ledelse-32px.svg": 1097,
	"./32px/graduation-cap-32px.svg": 1098,
	"./32px/graph-2-32px.svg": 1099,
	"./32px/graph-up-32px.svg": 1100,
	"./32px/hammer-32px.svg": 1101,
	"./32px/heart-32px.svg": 1102,
	"./32px/innovasjon-32px.svg": 1103,
	"./32px/klima-og-miljo-32px.svg": 1104,
	"./32px/leaf-32px.svg": 1105,
	"./32px/medal-1-32px.svg": 1106,
	"./32px/people-32px.svg": 1107,
	"./32px/piggy-bank-32px.svg": 1108,
	"./32px/samarbeid-32px.svg": 1109,
	"./32px/shacking-hands-32px.svg": 1110,
	"./32px/soccer-shoe-32px.svg": 1111,
	"./32px/stethoscope-32px.svg": 1112,
	"./32px/strategien-32px.svg": 1113,
	"./32px/sun-32px.svg": 1114,
	"./32px/supercar-32px.svg": 1115,
	"./32px/tractor-32px.svg": 1116,
	"./32px/umbrella-open-32px.svg": 1117,
	"./32px/vo-anlegg-32px.svg": 1118,
	"./32px/vo-bygg-32px.svg": 1119,
	"./32px/vo-eiendom-32px.svg": 1120,
	"./32px/vo-energi-32px.svg": 1121,
	"./32px/vo-miljo-32px.svg": 1122,
	"./32px/vo-offshore-32px.svg": 1123,
	"./32px/volleyball-32px.svg": 1124,
	"./32px/wall-32px.svg": 1125,
	"./48px/ID-card-48px.svg": 1126,
	"./48px/bar-chart-up-48px.svg": 1127,
	"./48px/bill-2-48px.svg": 1128,
	"./48px/binoculars-48px.svg": 1129,
	"./48px/bulb-idea-48px.svg": 1130,
	"./48px/chat-3-48px.svg": 1131,
	"./48px/coins-2-48px.svg": 1132,
	"./48px/construction-helmet-48px.svg": 1133,
	"./48px/diploma-3-48px.svg": 1134,
	"./48px/discount-star-48px.svg": 1135,
	"./48px/document-pencil-48px.svg": 1136,
	"./48px/fag-og-ledelse-48px.svg": 1137,
	"./48px/graduation-cap-48px.svg": 1138,
	"./48px/graph-2-48px.svg": 1139,
	"./48px/graph-up-48px.svg": 1140,
	"./48px/hammer-48px.svg": 1141,
	"./48px/heart-48px.svg": 1142,
	"./48px/innovasjon-48px.svg": 1143,
	"./48px/klima-og-miljo-48px.svg": 1144,
	"./48px/leaf-48px.svg": 1145,
	"./48px/medal-1-48px.svg": 1146,
	"./48px/people-48px.svg": 1147,
	"./48px/piggy-bank-48px.svg": 1148,
	"./48px/samarbeid-48px.svg": 1149,
	"./48px/shaking-hands-48px.svg": 1150,
	"./48px/soccer-shoes-48px.svg": 1151,
	"./48px/step-circle-01-48px.svg": 1152,
	"./48px/step-circle-02-48px.svg": 1153,
	"./48px/step-circle-03-48px.svg": 1154,
	"./48px/step-circle-04-48px.svg": 1155,
	"./48px/step-circle-05-48px.svg": 1156,
	"./48px/step-circle-06-48px.svg": 1157,
	"./48px/step-circle-07-48px.svg": 1158,
	"./48px/step-circle-08-48px.svg": 1159,
	"./48px/step-circle-09-48px.svg": 1160,
	"./48px/step-circle-10-48px.svg": 1161,
	"./48px/step-pyramid-00-48px.svg": 1162,
	"./48px/step-pyramid-01-48px.svg": 1163,
	"./48px/step-pyramid-02-48px.svg": 1164,
	"./48px/step-pyramid-03-48px.svg": 1165,
	"./48px/stethoscope-48px.svg": 1166,
	"./48px/strategien-48px.svg": 1167,
	"./48px/sun-48px.svg": 1168,
	"./48px/supercar-48px.svg": 1169,
	"./48px/tractor-48px.svg": 1170,
	"./48px/umbrella-open-48px.svg": 1171,
	"./48px/vo-anlegg-48px.svg": 1172,
	"./48px/vo-bygg-48px.svg": 1173,
	"./48px/vo-eiendom-48px.svg": 1174,
	"./48px/vo-energi-48px.svg": 1175,
	"./48px/vo-miljo-48px.svg": 1176,
	"./48px/vo-offshore-48px.svg": 1177,
	"./48px/volleyball-48px.svg": 1178,
	"./48px/wall-48px.svg": 1179,
	"./60px/ID-card-60px.svg": 1180,
	"./60px/bar-chart-up-60px.svg": 1181,
	"./60px/bill-2-60px.svg": 1182,
	"./60px/binoculars-60px.svg": 1183,
	"./60px/bulb-idea-60px.svg": 1184,
	"./60px/chat-3-60px.svg": 1185,
	"./60px/coins-2-60px.svg": 1186,
	"./60px/construction-helmet-60px.svg": 1187,
	"./60px/diploma-3-60px.svg": 1188,
	"./60px/discount-star-60px.svg": 1189,
	"./60px/document-pencil-60px.svg": 1190,
	"./60px/fag-og-ledelse-60px.svg": 1191,
	"./60px/graduation-cap-60px.svg": 1192,
	"./60px/graph-2-60px.svg": 1193,
	"./60px/graph-up-60px.svg": 1194,
	"./60px/hammer-60px.svg": 1195,
	"./60px/heart-60px.svg": 1196,
	"./60px/innovasjon-60px.svg": 1197,
	"./60px/klima-og-miljo-60px.svg": 1198,
	"./60px/leaf-60px.svg": 1199,
	"./60px/medal-1-60px.svg": 1200,
	"./60px/people-60px.svg": 1201,
	"./60px/piggy-bank-60px.svg": 1202,
	"./60px/samarbeid-60px.svg": 1203,
	"./60px/shacking-hands-60px.svg": 1204,
	"./60px/soccer-shoe-60px.svg": 1205,
	"./60px/step-circle-01-60px.svg": 1206,
	"./60px/step-circle-02-60px.svg": 1207,
	"./60px/step-circle-03-60px.svg": 1208,
	"./60px/step-circle-04-60px.svg": 1209,
	"./60px/step-circle-05-60px.svg": 1210,
	"./60px/step-circle-06-60px.svg": 1211,
	"./60px/step-circle-07-60px.svg": 1212,
	"./60px/step-circle-08-60px.svg": 1213,
	"./60px/step-circle-09-60px.svg": 1214,
	"./60px/step-circle-10-60px.svg": 1215,
	"./60px/stethoscope-60px.svg": 1216,
	"./60px/strategien-60px.svg": 1217,
	"./60px/sun-60px.svg": 1218,
	"./60px/supercar-60px.svg": 1219,
	"./60px/tractor-60px.svg": 1220,
	"./60px/umbrella-open-60px.svg": 1221,
	"./60px/vo-anlegg-60px.svg": 1222,
	"./60px/vo-bygg-60px.svg": 1223,
	"./60px/vo-eiendom-60px.svg": 1224,
	"./60px/vo-energi-60px.svg": 1225,
	"./60px/vo-miljo-60px.svg": 1226,
	"./60px/vo-offshore-60px.svg": 1227,
	"./60px/volleyball-60px.svg": 1228,
	"./60px/wall-60px.svg": 1229,
	"./BusinessAreas/fag-og-ledelse.svg": 1230,
	"./BusinessAreas/innovasjon.svg": 1231,
	"./BusinessAreas/klima-og-miljo.svg": 1232,
	"./BusinessAreas/samarbeid.svg": 1233,
	"./BusinessAreas/strategien.svg": 1234,
	"./BusinessAreas/vo-anlegg-60px.svg": 1235,
	"./BusinessAreas/vo-bygg-60px.svg": 1236,
	"./BusinessAreas/vo-eiendom-60px.svg": 1237,
	"./BusinessAreas/vo-energi-60px.svg": 1238,
	"./BusinessAreas/vo-miljo-60px.svg": 1239,
	"./BusinessAreas/vo-offshore-60px.svg": 1240,
	"./Strategies/fag-og-ledelse.svg": 1241,
	"./Strategies/innovasjon.svg": 1242,
	"./Strategies/klima-og-miljo.svg": 1243,
	"./Strategies/samarbeid.svg": 1244,
	"./arrow-down.svg": 1245,
	"./arrow-grey-left.svg": 1246,
	"./arrow-grey-light-close.svg": 1247,
	"./arrow-grey-light-left.svg": 1248,
	"./arrow-grey-light-right.svg": 1249,
	"./arrow-grey-right.svg": 1250,
	"./arrow-left.svg": 1251,
	"./arrow-line-left.svg": 1252,
	"./arrow-line-long-right.svg": 1253,
	"./arrow-line-right.svg": 1254,
	"./arrow-line-top.svg": 1255,
	"./arrow-right.svg": 1256,
	"./arrows.svg": 1257,
	"./binoculars.svg": 1258,
	"./briefcase.svg": 1259,
	"./calendar-add.svg": 1260,
	"./calendar.svg": 1261,
	"./camera-tripod-24px.svg": 1262,
	"./checkmark.svg": 1263,
	"./close.svg": 1264,
	"./download.svg": 1265,
	"./email.svg": 1266,
	"./facebook.svg": 1267,
	"./filetable.svg": 1268,
	"./grid.svg": 1269,
	"./hamburger.svg": 1270,
	"./icon-share.svg": 1271,
	"./instagram.svg": 1272,
	"./linkedin.svg": 1273,
	"./list.svg": 1274,
	"./location.svg": 1275,
	"./magnifier.svg": 1276,
	"./map.svg": 1277,
	"./minus-circle.svg": 1278,
	"./minus.svg": 1279,
	"./pdf.svg": 1280,
	"./plus-circle.svg": 1281,
	"./plus.svg": 1282,
	"./printer.svg": 1283,
	"./search.svg": 1284,
	"./share.svg": 1285,
	"./twitter.svg": 1286,
	"./youtube.svg": 1287,
	"./zoom-in.svg": 1288,
	"./zoom-out.svg": 1289
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 341;



//////////////////
// WEBPACK FOOTER
// ./data/assets/sprites \.svg$
// module id = 341
// module chunks = 0